export default "__VITE_ASSET__DIqdl34p__"